/**
 *
 * @param {*回调} fn
 * @param {*延迟时间} delay
 * @param {*强制执行时间} mustRunDelay
 */
export function throttle(fn, delay, mustRunDelay = 0) {
    let timer = null
    let tStart // 创建父级作用域时间tag
    return function () {
        const context = this
        const args = arguments
        const tCurr = +new Date()// 子作用域时间tag
        clearTimeout(timer)// 每次执行，先清空定时器，这步操作便是delay时间内舍弃多余操作的实现
        if (!tStart) { // 首次给时间tag赋值
            tStart = tCurr
        }
        // 这层判断就是判断是否达到强制执行的条件
        if (mustRunDelay !== 0 && tCurr - tStart >= mustRunDelay) {
            fn.apply(context, args)
            tStart = tCurr
        } else {
            timer = setTimeout(function () {
                fn.apply(context, args)
            }, delay)
        }
    }
}